 import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken } from "../Global";
import {MaterialReactTable} from 'material-react-table';
// import Swal from 'sweetalert2';
// import {  MenuItem} from '@mui/material';
// import { AccountCircle, Send } from '@mui/icons-material';
// //import Button from '@mui/material/Button';
// import ButtonGroup from '@mui/material/ButtonGroup';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
// import ClickAwayListener from '@mui/material/ClickAwayListener';
// import Grow from '@mui/material/Grow';
// import Paper from '@mui/material/Paper';
// import Popper from '@mui/material/Popper';
// //import MenuItem from '@mui/material/MenuItem';
// import MenuList from '@mui/material/MenuList';
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
const ViewProductionFeedGropyBy = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});
   let season_id = localStorage.getItem("season_id");

  useEffect(() => {
        setPermission(FindModuleById(71)); 
console.log(permission);

    axios
      .get(`/production-feeds/listing-groupby-all/${id+'_'+season_id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.productions);
          setData(response.data.data.productions_all);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };
  
  const columns = [
  {
    accessorKey: 'date_time',
    header: 'Date and Time',
  },
  {
    accessorKey: 'shift',
    header: 'Shift', // Fixed capitalization
  },
  {
    accessorKey: 'total_weight',
    header: 'Net Weight',
  },
  {
    header: 'Palletisation', // Fixed spelling (removed duplicate)
    accessorFn: (row) => {
      if (row.type === 'raw') {
        return row.barcode || '';
      }
      if (row.type === 'return') {
        return row.barcode_number || '';
      }
      return '';
    },
  },
  {
    header: 'Raw Material / Production Out',
    accessorFn: (row) => {
      if (row.type === 'raw') {
        return row.lot_number || '';
      }
      if (row.type === 'return') {
        return 'Return';
      }
      return '';
    },
  },
  {
    header: 'Created By',
    accessorFn: (row) => 
      row.createdby 
        ? `${row.createdby.first_name} ${row.createdby.last_name}` 
        : '',
  },
  {
    header: 'Updated By',
    accessorFn: (row) => 
      row.updatedby 
        ? `${row.updatedby.first_name} ${row.updatedby.last_name}` 
        : '',
  },
];
 
  //  const viewItem = (item)=>{
  //   window.location.href = "/production-feeds-view/"+item;
  // }

  // const editItem = (item)=>{
  //   window.location.href = "/production-feeds-edit/"+item;
  // }


  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Productions Feed Group By Shift Date, Location and Shift</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/production-feeds">Productions Feed</Link>
                    </li>
                    <li className="breadcrumb-item active">
                    Productions Feed Group By Shift Date, Location and Shift
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Productions Feed Group By Shift Date, Location and Shift</h4>
                    <table className="table table-bordered">
                      <tr>
                        <th className="p-3">Date</th>
                        <td className="p-3">{value.shift_date}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Location</th>
                        <td className="p-3">
                          {value.location ? value.location_name : ""}
                        </td>
                      </tr>
                      <tr>
                        <th className="p-3">Shift</th>
                        <td className="p-3">{value.shift}</td>
                      </tr>
                      </table>
                   
                  </div>
                </div>
              </div>
            </div>

            
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Listing Productions Feed</h4>
                    <div className="table-responsive">
                        <MaterialReactTable columns={columns} data={data} 
                          enableColumnOrdering
                          enablePinning
                          //enableRowActions
                          //renderColumnActionsMenuItems 
                          // renderRowActionMenuItems={({ row }) => [
                          //   <MenuItem key="edit" onClick={() => editItem(row.original.feed_id)}>
                          //     Edit
                          //   </MenuItem>
                         
                          // ]}
                        />
                      </div>
                  </div>
                </div>
              </div>
            </div>
         
          </div>
        </div>
      </div>
    </>
  );
};
export default ViewProductionFeedGropyBy;
